<template>
    <div v-if="item.relatedEntityType === 'Stop'">
        Stop
        <router-link
            :to="{
                name: 'Stop Details',
                params: { stopId: item.relatedEntityId }
            }"
            target="_blank"
        >
            {{ item.reference }}
        </router-link>
    </div>
    <div v-else-if="item.relatedEntityType === 'Trip'">
        Trip
        <router-link
            :to="{
                name: 'Trip Details',
                params: { tripId: item.relatedEntityId }
            }"
            target="_blank"
        >
            {{ item.reference }}
        </router-link>
    </div>
    <div v-else-if="item.relatedEntityType === 'Shipment'">
        Shipment
        <router-link
            :to="{
                name: 'Shipment Details',
                params: { shipmentId: item.relatedEntityId }
            }"
            target="_blank"
        >
            {{ item.reference }}
        </router-link>
    </div>
    <div v-else-if="item.relatedEntityType === 'CustomerInvoice'">
        Customer Invoice
        <router-link
            :to="{
                name: 'Customer Invoice Details',
                params: { invoiceId: item.relatedEntityId }
            }"
            target="_blank"
        >
            {{ item.reference }}
        </router-link>
    </div>
    <div v-else-if="item.relatedEntityType === 'TeamMemberInvoice'">
        Team Member Invoice
        <router-link
            :to="{
                name: 'Team Member Invoice Details',
                params: { invoiceId: item.relatedEntityId }
            }"
            target="_blank"
        >
            {{ item.reference }}
        </router-link>
    </div>
</template>

<script>
export default {
    name: 'IssueRoutedEntity',
    props: {
        item: {
            type: Object,
            default: () => {}
        }
    }
};
</script>
